import type { IconSvgObject } from './types';

const NavigationTwoIcon: IconSvgObject = [
  ["path", { d: "M11.9999 17L18.8177 20.8959C18.9371 20.9641 19.0723 21 19.2098 21C19.6462 21 19.9999 20.6462 19.9999 20.2098V20.1741C19.9999 20.0593 19.976 19.9458 19.9297 19.8407L12.7018 3.45746C12.5791 3.17941 12.3038 3 11.9999 3C11.696 3 11.4208 3.17941 11.2981 3.45746L4.07021 19.8407C4.02387 19.9458 3.99994 20.0593 3.99994 20.1741V20.2098C3.99994 20.6462 4.35371 21 4.7901 21C4.92761 21 5.06274 20.9641 5.18213 20.8959L11.9999 17Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default NavigationTwoIcon;
